import { useEffect, useRef, useState } from "react"
import { FiInfo } from "react-icons/fi"

export default function InfoPopover({ text }: { text: string }) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  return (
    <div className="relative inline-flex" ref={ref}>
      <button
        type="button"
        aria-label="More information"
        onClick={() => setOpen((v) => !v)}
        className="flex h-4 w-4 items-center justify-center rounded-full text-gray-400 hover:text-dantzBlue"
      >
        <FiInfo size={13} />
      </button>

      {open && (
        <div className="absolute left-1/2 top-full z-20 mt-2 w-56 -translate-x-1/2 rounded-lg border border-gray-200 bg-white p-3 text-xs font-normal normal-case leading-relaxed tracking-normal text-gray-600 shadow-lg">
          {text}
        </div>
      )}
    </div>
  )
}
